import { TableRow, TableCell } from "@mui/material";
import { MemoryBook } from "../../../../../types/memory-table";
import PropTypes from "prop-types";

interface MemoryBookTableRowProps {
  memoryBook: MemoryBook;
}

export const MemoryBookTableRow: React.FC<MemoryBookTableRowProps> = ({
  memoryBook,
}) => {
  const date = new Date(memoryBook.created_at).toLocaleDateString("en-GB", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });

  const determineUploadedName = (): string | undefined => {
    if (
      memoryBook.created_by.first_name.length === 0 ||
      memoryBook.created_by.last_name.length === 0
    ) {
      return memoryBook.created_by.username;
    }

    return `${memoryBook.created_by.first_name} ${memoryBook.created_by.last_name}`;
  };

  return (
    <TableRow
      key={memoryBook.id}
      sx={{
        "&:last-child td, &:last-child th": { border: 0 },
        padding: 50,
      }}
    >
      <TableCell>{memoryBook.file.split("/").at(-1)}</TableCell>
      <TableCell>{determineUploadedName()}</TableCell>
      <TableCell>{date}</TableCell>
    </TableRow>
  );
};

MemoryBookTableRow.propTypes = {
  memoryBook: PropTypes.shape({
    id: PropTypes.number.isRequired,
    created_at: PropTypes.string.isRequired,
    created_by: PropTypes.shape({
      first_name: PropTypes.string.isRequired,
      last_name: PropTypes.string.isRequired,
      username: PropTypes.string.isRequired,
    }).isRequired,
    file: PropTypes.string.isRequired,
  }).isRequired,
};
